<template>
  <div class="card-450 rounded w-100 p-2">


    <div class="row">
      <div class="col-9">
        <slot name="p-1">
          ارسال بار از دزفول
        </slot>
      </div>
      <div class="col-3 p-0">
        <slot name="p-2">
          1400/07/14
        </slot>
      </div>
    </div>

    <hr>

    <div class="row">

      <div class="col-12"><i class="bi bi-circle-fill"></i>
        <slot name="p-3">
          دزفول
        </slot>
      </div>
      <div class="col-12">
        <i class="bi bi-three-dots-vertical"></i>
      </div>
      <div class="col-12">
        <i class="bi bi-collection-fill"></i>
        <slot name="p-4">
          اهواز
        </slot>
      </div>
    </div>

    <hr>

    <div class="row">

      <div class="col-5">
        <slot name="p-5">
          صافی کل <span class="text-primary">400.000</span> تومان
        </slot>
      </div>
      <div class="text-left col-7">
        <slot name="p-6">
          اتاقدار
        </slot>
      </div>

      <div class="col-12">
        <slot name="p-7"></slot>
      </div>


    </div>


    <slot name="p-bottom"></slot>


  </div>
</template>

<script>
import mA from '../Tags/A'
import mImg from '../Tags/Img'
import {CardProps} from "./CardProps";

export default {
  name: "Card450",
  components: {
    mA,
    mImg,
  },
  props: {
    ...CardProps
  },
}

</script>

<style scoped>
.card-450 {
  border: 1px solid rgb(196, 196, 196);
}

</style>